<template>
  <div class="view box grow" style="overflow-y: auto">
    <p class="confluer-reports-header">CONFLUERA REPORTS</p>
    <page-headers
      :is-border="false"
      class="box"
    >
    <div class="slot float-right footer">
        <span slot="footer" class="dialog-footer">
          <el-button>
            User Guid
          </el-button>
          <el-button type="primary">
            Add Report<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
        </span>
      </div>
    </page-headers>
    <el-tabs v-model="activeView" @tab-click="changeView">
      <el-tab-pane :span="4" label="Templates" name="templates"></el-tab-pane>
      <el-tab-pane :span="20" label="Scheduled Reports" name="scheduled"></el-tab-pane>
    </el-tabs>
    <router-view class="full-height" />
  </div>
</template>

<script>
import PageHeaders from '@/components/layout/PageHeaders.vue'

export default {
  name: 'ReportsView',
  data () {
    return {
      header: 'Confluera Reports',
      breadcrumbs: [{ title: 'Templates' }, { title: 'Scheduled Reports' }],
      activeView: 'templates',
      routePath: '/reports/templates'
    }
  },
  beforeMount () {
    // If window refreshed, stay on previous rules page
    if (performance.navigation.type === 1) {
      this.$router.push({ name: this.$route.name, params: this.$route.params, query: this.$route.query })
      this.activeView = this.$route.path.split('/').reverse()[0]
    } else {
      // set default path for attack progression rules
      this.$router.push({ name: 'reports-templates', params: this.$route.params, query: this.$route.query })
    }

    if (this.activeView === 'scheduled') {
      this.routePath = '/reports/scheduled'
    }
  },
  methods: {
    changeView (tab, event) {
      if (tab.name === 'templates') {
        this.routePath = '/reports/templates'
      } else {
        this.routePath = '/reports/scheduled'
      }
      this.$router.push(this.routePath)
    }
  },
  watch: {
    $route(to, from) {
      this.activeView = 'scheduled'
    }
  },
  components: {
    PageHeaders
  }
}
</script>

<style scoped>

.confluer-reports-header {
  height: 15px;
  width: 146px;
  color: #454B60;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 15px;
  margin-bottom: -11px;
  padding-top: 19px;
}
</style>



// WEBPACK FOOTER //
// src/views/reports/ReportsView.vue